import { setAIVoices } from './ai-voices-slices';

import { ApiService } from 'js/src/client';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';

export const fetchAIVoices = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.aiVoiceList();
            const voices = response.data;
            dispatch(setAIVoices(voices));
            return true;
        } catch (error) {
            ErrorReporter.capture(error);
            return false;
        }
    };
};
